export const USER_PERMISSIONS_KEYS = {
    all: ['user-permissions'] as const,
    allowedCompanies: (userId: string) => [...USER_PERMISSIONS_KEYS.all, 'allowed-companies', userId] as const,
    allowedCategories: (userId: string) => [...USER_PERMISSIONS_KEYS.all, 'allowed-categories', userId] as const,
};
